module.exports = __webpack_public_path__ + "static/converge2-481dc268aed1a400c5213633528edbac.jpg";